import { connect } from "react-redux";

import * as homeActions from "../../home/actions";
import * as balanceActions from "./account.balance.actions";

function mapStateToProps(state) {
  return {
    home: state.home,
    financings: state.financing.financings.data,
    loanpayouts: state.financing.loansForPayout.data,
    applications: state.applications.creditApplications.data,
    loans: state.loans.data,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchAccountBalanceForDay: (day) => {
      dispatch(balanceActions.fetch_account_balance_for_day(day));
    },

    fetchDashboardLoanData: () => {
      dispatch(homeActions.fetch_dashboard_loan_data());
    },

    fetchStatistics: (date) => {
      dispatch(homeActions.fetch_statistics(date));
    },

    fetchDepots: (date) => {
      dispatch(homeActions.fetch_depots(date));
    },

    fetchDepotsRange: (from, to) => {
      dispatch(homeActions.fetch_depots_range(from, to));
    },
  };
}

export const dashboardConnector = connect(mapStateToProps, mapDispatchToProps);
